import { StyleSheet } from "aphrodite";
import ColorCatalog from "../../../../app/ui/color/ColorCatalog";

const styles = StyleSheet.create({
  selectableRow: {
    cursor: "pointer",
    ":hover": {
      backgroundColor: ColorCatalog.info,
    },
  },

  selectedRow: {
    backgroundColor: ColorCatalog.primary,
  },

  selectedCell: {
    color: ColorCatalog.primary_contrast,
  },

  shortcutCell: {
    width: 100,
  },
});

export default styles;
